import React, { useCallback, useEffect, useState, useRef } from 'react';
// import { useTranslation } from "react-i18next";
import Table from 'react-bootstrap/Table';
import { motion } from "framer-motion";
import "./index.scss";

import Pagination from "../../../../../../ui/Pagination";
import NoDataFound from "../../../../../../ui/NoDataFound";
import SkeletonLoader from "../../../../../../ui/SkeletonLoader";

import { useSelector, useDispatch } from 'react-redux';
import { getIpAddressSubdomain } from "../../../../../../../store/actions/scanInfoAction";


const SubDomains = ({selectedIpDetails, domainId, scanId}) => {

    const ipAddressSubDomainList = useSelector((state) => state?.scanInfo.ipAddressSubDomainList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef= useRef(null)

    const dispatch = useDispatch();

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const fetchIpAddressSubDomainList = useCallback(()=>{
        setIsLoading(true)
        let url = `&page=${currentPage}&page_size=${currentPageSize}&domain=${selectedIpDetails?.domain}&scan_id=${selectedIpDetails?.scan_id}&ip_address=${selectedIpDetails?.ip_address}`
        dispatch(getIpAddressSubdomain(url))

    },[dispatch, selectedIpDetails, currentPage, currentPageSize])

    useEffect(()=>{
        setCurrentPage(1)
    },[selectedIpDetails])

    useEffect(()=>{
        if(selectedIpDetails || domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {            
            fetchIpAddressSubDomainList();
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId;
        }
    },[domainId, scanId, fetchIpAddressSubDomainList, selectedIpDetails]);

    useEffect(()=>{
        if(ipAddressSubDomainList !== null) {
            setIsLoading(false)
        }
    },[ipAddressSubDomainList])

    return (
        <>
            <div className="ip-subdomain-table">
                {
                    isLoading ? 
                    <SkeletonLoader type={"line"} count={5} currentPage={"ipaddress"} />
                    :
                    <Table responsive="lg">
                        <thead>
                            <tr>
                                <th>Subdomain</th>
                                <th>Type</th>
                                <th>HTTP/HTTPS Status</th>
                                <th>Webserver</th>
                                <th>Force HTTPS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                ipAddressSubDomainList?.results.length > 0 &&
                                ipAddressSubDomainList?.results.map((data, index) => {
                                    return (
                                        <motion.tr
                                            key={index}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                        >
                                            <td>{data?.subdomain}</td>
                                            <td>{data?.subdomain_type}</td>
                                            <td>
                                                {<span className={`http-status ${data?.http_status.http ? 'active' : 'inactive'}`}>{data?.http_status.http ? "HTTP Active" : "HTTP Inactive"}</span>}
                                                <span className={`http-status ${data?.http_status.https ? 'active' : 'inactive'}`}>{data?.http_status.https ? "HTTPS Active" : "HTTP Inactive"}</span>
                                            </td>
                                            <td>{data?.webserver !== null ? data?.webserver : "-"}</td>
                                            <td>{data?.forced_https !== null ? data?.forced_https ? "True" : "false" : "-"}</td>
                                        </motion.tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                }                
                {
                    !isLoading && ipAddressSubDomainList !== null && ipAddressSubDomainList?.results.length === 0 &&
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <NoDataFound noDataText={"No Record Found"}/>
                    </motion.div>                    
                }
                {ipAddressSubDomainList !== "" && ipAddressSubDomainList?.results.length > 0 && <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    pageSize={currentPageSize}
                    totalCount={ipAddressSubDomainList?.meta?.total_results}
                    onPageChange={setCurrentPageandRecordSize}
                />}
            </div>
        </>
    )
}

export default SubDomains;